// import { Button } from "antd";
// import { FilePdfOutlined } from "@ant-design/icons";
import { CredencialButtonV2 } from "../../components/commons";
// import { CredencialButton } from "../../components/commons";

/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} downloadFilePDF
 * @param {Number} page
 */
export function createColumns(page = 1, downloadFilePDF = null) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Tipo",
      dataIndex: "tipoparticipacion",
      key: "tipoparticipacion",
      sorter: (a, b) => a.tipoparticipacion.localeCompare(b.tipoparticipacion),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento)
    },
    {
      title: "Correlativo",
      dataIndex: "correlativo",
      key: "correlativo",
      sorter: (a, b) => a.correlativo.localeCompare(b.correlativo),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Apellidos",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Nombres",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      sorter: (a, b) => a.color.localeCompare(b.color),
      sortDirections: ["descend", "ascend"]
    },
    // {
    //   title: "Acciones",
    //   key: "action",
    //   render: (record) => <CredencialButton user={record} />
    // }
    {
      title: "Acciones",
      key: "action",
      render: (record) => <CredencialButtonV2 user={record} />
    }
  ];
}
